import { baseFetchToken } from './BaseSaga'
import BrandActions from '../Redux/BrandRedux'
import { getToken } from '../Services/GetToken'

export function * getBrand (api, action) {
  yield baseFetchToken(
    api.getBrand,
    action.data,
    getToken,
    BrandActions.getBrandSuccess,
    BrandActions.getBrandFailure
  )
}

export function * createBrand (api, action) {
  yield baseFetchToken(
    api.createBrand,
    action.data,
    getToken,
    BrandActions.createBrandSuccess,
    BrandActions.createBrandFailure
  )
}

export function * updateBrand (api, action) {
  yield baseFetchToken(
    api.updateBrand,
    action.data,
    getToken,
    BrandActions.updateBrandSuccess,
    BrandActions.updateBrandFailure
  )
}

export function * deleteBrand (api, action) {
  yield baseFetchToken(
    api.deleteBrand,
    action.data,
    getToken,
    BrandActions.deleteBrandSuccess,
    BrandActions.deleteBrandFailure
  )
}

export function * getSingleBrand (api, action) {
  yield baseFetchToken(
    api.getSingleBrand,
    action.data,
    getToken,
    BrandActions.getSingleBrandSuccess,
    BrandActions.getSingleBrandFailure
  )
}

export function * createCategoryBrand (api, action) {
  yield baseFetchToken(
    api.createCategoryBrand,
    action.data,
    getToken,
    BrandActions.createCategoryBrandSuccess,
    BrandActions.createCategoryBrandFailure
  )
}

export function * updateCategoryBrand (api, action) {
  yield baseFetchToken(
    api.updateCategoryBrand,
    action.data,
    getToken,
    BrandActions.updateCategoryBrandSuccess,
    BrandActions.updateCategoryBrandFailure
  )
}

export function * deleteCategoryBrand (api, action) {
  yield baseFetchToken(
    api.deleteCategoryBrand,
    action.data,
    getToken,
    BrandActions.deleteCategoryBrandSuccess,
    BrandActions.deleteCategoryBrandFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/BrandSagas.js